export default "__VITE_ASSET__BATOtU1s__"